import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axiosInstance from '../../axios';
import { Card, Title, Text, Table, Button, Box } from '@nimbus-ds/components';
import { Page } from '@nimbus-ds/patterns';

interface AuctionOffer {
  id: number;
  customer_name: string;
  amount: string;
  created_at: string;
}

interface AuctionDetail {
  id: number;
  name: string;
  handle: string;
  price_base: string;
  price_gap: string;
  offer_gap: number;
  status: string;
  fecha_finalizacion: string;
  ganador: string | null;
  offers: AuctionOffer[];
}

const AuctionDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { goBack } = useHistory();
  const [auction, setAuction] = useState<AuctionDetail | null>(null);

  const fetchDetail = async () => {
    try {
      const res = await axiosInstance.get(`/auction_detail/${id}`);
      if (res.data?.status === 'SUCCESS') {
        setAuction({
          ...res.data.auction,
          offers: res.data.offers, // <-- incorporar manualmente
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  const formatDateTime = (iso: string) => {
    const date = new Date(iso);

    // Ajusta a la zona horaria de Argentina (UTC-3)
    const options: Intl.DateTimeFormatOptions = {
      timeZone: 'America/Argentina/Buenos_Aires',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };

    const formatter = new Intl.DateTimeFormat('es-AR', options);
    return formatter.format(date).replace(',', '');
  };

  if (!auction) return <Text>Cargando...</Text>;

  return (
    <Page maxWidth="800px">
      <Page.Header
        title={`Detalle subasta: ${auction.name}`}
        buttonStack={
          <Button onClick={() => goBack()} appearance="primary">
            Volver
          </Button>
        }
      />
      <Page.Body>
        <Card>
          <Box display="grid" gridTemplateColumns="1fr 1fr" gap="4">
            <Text>
              <strong>Nombre:</strong> {auction.name}
            </Text>
            <Text>
              <strong>Denominación:</strong> {auction.handle}
            </Text>
            <Text>
              <strong>Precio base:</strong> ${auction.price_base}
            </Text>
            <Text>
              <strong>gap (precio):</strong> ${auction.price_gap}
            </Text>
            <Text>
              <strong>gap (monto):</strong> {auction.offer_gap}
            </Text>
            <Text>
              <strong>Estado:</strong> {auction.status}
            </Text>
            <Text>
              <strong>Finaliza:</strong>{' '}
              {formatDateTime(auction.fecha_finalizacion)}
            </Text>
            <Text>
              <strong>Ganador:</strong> {auction.ganador || 'Sin ganador'}
            </Text>
          </Box>
        </Card>

        <Box marginTop="6">
          <Title fontSize="4">Historial de ofertas</Title>
          <Table>
            <Table.Head>
              <Table.Cell>ID</Table.Cell>
              <Table.Cell>Ofertante</Table.Cell>
              <Table.Cell>Monto</Table.Cell>
              <Table.Cell>Fecha</Table.Cell>
            </Table.Head>
            <Table.Body>
              {auction.offers.map((offer) => (
                <Table.Row key={offer.id}>
                  <Table.Cell>{offer.id}</Table.Cell>
                  <Table.Cell>{offer.customer_name}</Table.Cell>
                  <Table.Cell>${offer.amount}</Table.Cell>
                  <Table.Cell>{formatDateTime(offer.created_at)}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Box>
      </Page.Body>
    </Page>
  );
};

export default AuctionDetailPage;
